<template>
  <el-scrollbar
    id="main-scroll"
    ref="scroll"
    class="scroll main-scroll"
    :always="true"
    @scroll="handleScroll"
  >
    <slot></slot>
  </el-scrollbar>
</template>

<script>
import { mapActions, mapState } from 'pinia';

import { useStore } from '@/store/index';

export default {
  emits: ['scroll'],
  data() {
    return {
      scrollIconTimer: null,
    };
  },
  computed: {
    ...mapState(useStore, ['scrollHash']),
  },
  watch: {
    scrollHash(val) {
      if (val.flag) {
        if (val.speed) {
          this.smoothScrollTo(val.top, val.speed);
        } else {
          this.$refs.scroll?.scrollTo({
            top: val.top,
            behavior: val.behavior, // 滚动效果 smooth 平滑滚动  instant 立即滚动
          });
        }
        this.SET_SCROLLHASH({
          top: 0,
          flag: false,
          behavior: 'smooth',
        });
      }
    },
  },
  methods: {
    handleScroll(e) {
      try {
        const scrollTop = e.scrollTop;
        this.SET_SCROLLTOP(scrollTop);
        this.$emit('scroll', scrollTop);

        // 处理右侧悬浮图标的隐藏与展示
        this.SET_SCROLL_ICON_HIDE(true);
        clearTimeout(this.scrollIconTimer);
        this.scrollIconTimer = setTimeout(() => {
          console.log('@handleScroll-setTimeout');
          this.SET_SCROLL_ICON_HIDE(false);
        }, 1000);
      } catch {}
    },
    smoothScrollTo(targetY, duration) {
      const startY = window.scrollY;
      const distance = targetY - startY;
      const startTime = performance.now();
      const animation = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // 缓动函数
        const easeInOutQuad =
          progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;

        this.$refs.scroll?.scrollTo({
          top: startY + distance * easeInOutQuad,
          behavior: 'smooth',
        });

        if (progress < 1) {
          requestAnimationFrame(animation);
        }
      };

      requestAnimationFrame(animation);
    },
    ...mapActions(useStore, ['SET_SCROLLHASH', 'SET_SCROLLTOP', 'SET_SCROLL_ICON_HIDE']),
  },
};
</script>

<style lang="scss" scoped>
// :deep(.el-scrollbar__view) {
//   height: 100%;
// }
.scroll {
  height: 100%;
  :deep(.el-scrollbar__bar) {
    z-index: 120;
    right: 0;
    .el-scrollbar__thumb {
      background-color: #e3e1de;
      opacity: 1;
    }
  }
  .__view {
    width: 100% !important;
  }
}
</style>
